import React, { Component } from "react";
import { Container, Divider } from "@mui/material";
import { Box } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import PieGraph from "../components/ui-components/graphs/PieGraph";
import { getURLBase } from "../utils/helperFns";
import axios from "axios";
import MUISwitch from "../components/ui-components/toggleSwitch";

 class MonthlyBudget extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/monthlybudget";
        this.state = {
            isReady: false,
            currentViewisMoney: true
        };
    }

    componentDidMount() {
        if (!this.state.isReady) {
            axios.post(this.url, { gid: this.props.gid }).then(res => {
            this.setState({
                isReady: true,
                piedata: res.data.body.piedata,
                date_and_month: res.data.body.date_and_month
            });
        });
        }
    }

    handleSwitchToggle = () => {
        this.setState({
            currentViewisMoney: !this.state.currentViewisMoney,
        });
        if (!this.state.currentViewisMoney) {
            //this.processData(this.state.data.moneyTab.pieData);
            this.setState({ amountPrefix: "£" })
        } else {
            //this.processData(this.state.data.footprintTab.pieData);
            this.setState({ amountPrefix: "kg" })
        }
    };

    returnWhenStateReady = () => (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "20vh",
            }}
        >
            <CircularProgress color="success" />
        </Box>
    )

    render() {
        const WidgetData = () => (
            <Card className="widgetCard cardShadow" >
                <CardContent textAlign="center">
                    <Typography variant="h4" sx={{ fontWeight: 700, marginTop: "-15px"  }} align="center" mx={"auto"} width="70%">
                        Monthly Budget
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        fontWeight="600"
                        align="center"
                        gutterBottom
                    >
                        for {this.state.date_and_month}
                    </Typography>
                    <Divider light />
                    <Box mt={2} mb={1} className={`${this.state.isReady ? (`${this.state.piedata.committed.total === null || this.state.date_and_month == null ? "blur" : ""}`) : ""}`}  >
                        <Typography variant="h6" align="center" mx={"auto"} width="70%" sx={{ fontWeight: 600 }}>
                            Committed Spends
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            fontWeight="600"
                            align="center"
                            gutterBottom
                        >
                            Bills / Rent / Insurance ...
                        </Typography>

                        {
                            !this.state.isReady ? (<this.returnWhenStateReady />) :
                                <Container sx={{ padding: 5 }}>
                                    <PieGraph
                                        total={this.state.piedata.committed.total}
                                        piedata={this.state.piedata.committed.piedata}
                                        moreData={this.state.piedata.committed.moredata}
                                        colors={["#eee", "#e96e66"]}
                                    />
                                </Container>
                        }

                    </Box>

                    <Divider light sx={{ width:"480px",maxWidth: "100%", margin: "auto" }}/>
                    <Box mt={1} mb={4} className={`${this.state.isReady ? (`${this.state.piedata.nonCommitted.total === null || this.state.date_and_month == null ? " blur" : ""}`) : ""}`}>
                        <Typography variant="h6" align="center" mx={"auto"} width="70%" sx={{ fontWeight: 600 }}>
                            Miscellaneous Spends
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            fontWeight="600"
                            align="center"
                            gutterBottom
                        >
                            Shopping / Grocery / Food & Drinks / Transportation ...
                        </Typography>

                        {
                            !this.state.isReady ? (<this.returnWhenStateReady />) :
                                <Container sx={{ padding: 5 }}>
                                    <PieGraph
                                        total={this.state.piedata.nonCommitted.total}
                                        piedata={this.state.piedata.nonCommitted.piedata}
                                        moreData={this.state.piedata.nonCommitted.moredata}
                                        colors={["#eee", "#e96e66"]}
                                    />
                                </Container>
                        }

                    </Box>
                </CardContent>
            </Card>
        );

        // return <WidgetData />;
        return (
			<Box sx={{ position: "relative", width: "100%" }}>
				<Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
					<MUISwitch handleClick={this.handleSwitchToggle} />
				</Box>

				<WidgetData />


			</Box>
		);
    }
}

export default MonthlyBudget;
